import React from 'react';
import OverallScoreBlob from './../../OverallScore/OverallScoreBlob';
import RecommendedLabel from './../../RecommendedLabel';

export default ({product, onRemove}) => (
    <a href={product.overviewUrl} className="compare-bucket-item compare-bucket__button--model">
        <div>
            <img src={product.imageSource}/>
            <OverallScoreBlob
                type={product.overallScore.type}
                score={product.overallScore.value}
            />
        </div>
        <div className="crux-body-copy">
            <RecommendedLabel type={product.recommendedType} />
            <p className="crux-body-copy crux-body-copy--small--bold text-left ">{product.name.brandName} {product.name.productName}</p>
            <button className="close-icon" onClick={(event) => {
                onRemove(product.id);
                event.preventDefault();
            }}>
                <span className="crux-icons crux-icons-close compare-bucket__button--remove"/>
            </button>
        </div>
    </a>
);



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/components/CompareBucketRedux/components/CompareBucketItem.jsx